import { Toast } from "../Components/Dialog/Toast";

window.addEventListener("cart-add-success", (e: CustomEvent) => {
    new Toast({
        title: window.SuccessMessages.cart_add.success.replace(/{{\s?name\s?}}/, e.detail.items[0].title),
        type: Toast.TYPE_SUCCESS
    })?.render();
});

window.addEventListener("cart-http-error", (e: CustomEvent) => {
    let message;

    try {
        message = JSON.parse(e.detail.message);
    } catch (error) {}

    new Toast({
        title: message?.description ? message.description : window.SuccessMessages.cart_http.error,
        type: Toast.TYPE_ERROR
    })?.render();
});

window.addEventListener("show-generic-error-message", () => {
    new Toast({
        title: window.SuccessMessages.cart_http.error,
        type: Toast.TYPE_ERROR
    })?.render();
});
